<!--
 * @Author: zjw
 * @Date: 2021-05-18 15:56:15
 * @LastEditTime: 2022-11-18 17:19:41
 * @FilePath: \web-app\src\components\common\Header.vue
 * @Environment: Vue + Element
 * @Description: 头部组件
-->
<template>
  <div class="header">
    <div class="collapse-btn left" @click="collapseChage">
      <img class="showimg" :src="opened ? imgshow : imgsq" />
    </div>
    <h1>天途<img src="../../assets/img/common/icon.png" alt="">情报</h1>
    <!-- <bread-crumb class="breadCrumb left"></bread-crumb> -->
    <el-dropdown class="dropdown-menu right" @command="handleCommand" v-if="!(opened&&$route.path == '/homePage')">
      <span class="el-dropdown-link">
        <!-- <span>用户名</span> -->
        <i class="el-icon-setting el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" >
        <el-dropdown-item command="layout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
// import breadCrumb from "./Breadcrumb.vue";
import { store, mutations } from "../../store/observable";
import { mapState } from "vuex"
export default {
  name: "Header",
  // components: {
  //   breadCrumb,
  // },
  data() {
    return {
      userInfo: {},
      imgshow: require("@/assets/img/common/show.png"),
      imgsq: require("@/assets/img/common/sq.png"),
    };
  },
  //计算属性缓存数据
  computed: {
	...mapState(['opened']),
    projectName() {
      return store.projectName;
    },
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    collapseChage() {
      //修改state中的数据
      // mutations.setProjectName({
      //   projectName: this.opened ? "威胁情报后台管理" : "测试测试",
      // });
      //折叠切换状态事件, 修改store中opened在组件中监视以便实现图表自适应
      this.$store.commit("isOpened", !this.opened);
    },
    handleCommand(command) {
      // 清空item跳转登录页面
      localStorage.clear();
      this.$router.push("/");
    },
	
  },
 
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background: #334157;
  color: #fff;
  -webkit-box-shadow: 2px 1px 4px #eee;
  box-shadow: 2px 1px 4px #eee;
  box-sizing: border-box;
  h1{
	 display: flex;
	 align-items: center;
	 margin: auto;
	  img{
		  width: 50px;
		  height: 50px;
		  margin: 0 5px;
	  }
  }
  .el-dropdown-link {
    color: #ffffff;
  }
  // 折叠按钮
  .collapse-btn {
    width: 60px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    // text-align: center;
    cursor: pointer;
    // background: transparent;
    // background-color: rgb(179, 127, 127);

    // i {
    //   font-size: 22px;
    // }

    // &:hover {
    // background: #fafafa;
    // }

    // .buttonimg {
    //   height: 100%;
    //   background-color: transparent;
    //   border: none;
    // }
    .showimg {
      // width: 26px;
      height: 26px;
      // position: absolute;
      // top: 17px;
      // left: 17px;
    }
    // .showimg:active {
    //   border: none;
    // }
  }

  // 面包屑
  // .breadCrumb {
  //   height: 60px;
  //   display: flex;
  //   align-items: center;
  //   margin-left: 10px;
  // }

  //操作按钮
  .dropdown-menu {
    height: 60px;
    padding-right: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 22px;
    }
  }
}
// 当屏幕宽度大于1928的时候默认为210px
@media screen and (min-width: 1920px) {
  .header {
    height: 60px; /*no*/
  }
}
</style>
